import type { ServicesInsightsReportState } from './ServicesInsightsReportState';
import { initialServicesInsightsReportState } from './ServicesInsightsReportState';

import {
    SERVICES_INSIGHTS_REPORT_GET_ERROR,
    SERVICES_INSIGHTS_REPORT_GET_START,
    SERVICES_INSIGHTS_REPORT_GET_SUCCESS,
    type ServicesInsightsReportAction
} from 'actions/insights/sales/servicesInsightsReport/ServicesInsightsReportActionsTypes';

export const servicesInsightsReportReducer = (
    state: ServicesInsightsReportState = initialServicesInsightsReportState,
    action: ServicesInsightsReportAction
): ServicesInsightsReportState => {
    switch (action.type) {
        case SERVICES_INSIGHTS_REPORT_GET_START:
            return { ...state, loading: true };

        case SERVICES_INSIGHTS_REPORT_GET_SUCCESS:
            return { ...state, loading: false, report: action.payload.report };

        case SERVICES_INSIGHTS_REPORT_GET_ERROR:
            return { ...state, loading: false };

        default:
            return state;
    }
};
